<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
    <mat-drawer-container class="bg-card h-full flex-auto dark:bg-gray-400" (backdropClick)="onBackdropClicked()">
        <!-- Drawer -->
        <mat-drawer class="w-full dark:bg-gray-400 sm:w-100" [mode]="drawerMode" [opened]="fileDetailsDrawerState()"
            [position]="'end'" [disableClose]="true" #matDrawer>
            <app-file-details></app-file-details>
        </mat-drawer>
        <mat-drawer class="w-full dark:bg-gray-400 sm:w-1/2" [mode]="drawerMode" [opened]="fileUploadDrawerState()"
            [position]="'start'" [disableClose]="true" #matDrawer2>
            <app-file-upload></app-file-upload>
        </mat-drawer>
        <mat-drawer-content class="flex flex-col bg-gray-100 dark:bg-transparent">
            <!-- Main -->
            <div class="flex flex-auto flex-col">

                <div class="flex flex-row justify-between bg-primary text-white text-lg ">
                    <div></div>
                    <div class="p-2.5 pr-3">
                        File Manager for {{gridDocument().documentType}} - {{ gridDocument().documentReference }}
                    </div>
                    <button matDialogClose class="appDialogClose pr-2" (click)="onClose()">
                        <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
                <!-- Header -->
                <div
                    class="bg-card flex flex-col items-start border-b p-6 dark:bg-transparent sm:flex-row sm:items-center sm:justify-between sm:py-12 md:px-8">

                    <!-- Actions -->
                    <div class="mt-4 sm:mt-0">
                        <!-- Upload button -->
                        <button mat-flat-button [color]="'primary'" (click)="onUploadFile()">
                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            <span class="ml-2 mr-1">Upload file</span>
                        </button>
                    </div>
                </div>

                <!-- Items list -->
                @if (allFiles() && allFiles().length > 0) {
                <div class="space-y-8 p-6 md:p-8">
                    <!-- Folders -->

                    <!-- Files -->
                    <!-- @if (allFiles$) { -->
                    <div>
                        <div class="font-medium">Files</div>
                        <div class="-m-2 mt-2 flex flex-wrap">
                            @for (file of allFiles(); track file) {
                            <a class="bg-card m-2 flex h-40 w-40 cursor-pointer flex-col rounded-2xl p-4 shadow"
                                (click)="onFileClicked(file)">
                                <div class="aspect-[9/6]">
                                    <div class="flex h-full items-center justify-center">
                                        <!-- Icons -->
                                        <div class="relative">
                                            <mat-icon class="text-hint opacity-50 icon-size-14" [svgIcon]="
                                                    'heroicons_solid:document'
                                                "></mat-icon>
                                            <div class="absolute bottom-0 left-0 rounded px-1.5 text-sm font-semibold leading-5 text-white"
                                                [ngClass]="{
                                             'bg-red-600': file.extension === 'PDF',
                                             'bg-blue-600': file.extension === 'DOCX' || file.extension === 'DOC',
                                             'bg-green-600': file.extension === 'XLSX' || file.extension === 'XLS',
                                             'bg-amber-600': file.extension === 'JPG',
                                             'bg-yellow-600': file.extension === 'ZIP',
                                             'bg-purple-600': file.extension === 'PNG',
                                             'bg-gray-600': !['PDF', 'DOCX', 'DOC', 'XLSX', 'XLS', 'JPG', 'ZIP', 'PNG'].includes(file.extension)
                                           }">
                                                {{ file.extension.toUpperCase() }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-auto flex-col justify-center text-center text-sm font-medium">
                                    <div class="truncate" [matTooltip]="file.name">
                                        {{ file.name }}
                                    </div>
                                </div>
                            </a>
                            }
                        </div>
                    </div>
                    <!-- } -->
                </div>
                } @else {
                <div class="flex flex-auto flex-col items-center justify-center bg-gray-100 dark:bg-transparent">
                    <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                    <div class="text-secondary mt-4 text-2xl font-semibold tracking-tight">
                        There are no items!
                    </div>
                </div>
                }

                <!-- No items template -->
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>